import React from "react";
import { FaQuoteLeft } from "react-icons/fa";

function FirstSection() {
  return (
    <div className="first">
      <div className="first-con">
        <div>
          <h2>
            Digital
            <br /> Cosmetic Agency
          </h2>
          <br />
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro eaque
            labore ullam sint voluptatum exercitationem quisquam, distinctio
            ipsa excepturi tempore. Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Porro eaque labore ullam sint voluptatum
            exercitationem quisquam, distinctio ipsa excepturi tempore. Lorem
            ipsum dolor sit amet consectetur adipisicing elit. Porro eaque
            labore ullam sint voluptatum exercitationem quisquam, distinctio
          </p>
          <br />
          <button>Contact Us</button>
        </div>
        <h1>A</h1>
        <div>
          <span>
            <FaQuoteLeft />
          </span>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro eaque
            labore ullam sint voluptatum exercitationem quisquam, distinctio
            ipsa excepturi tempore. Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Porro eaque labore ullam sint voluptatum
            exercitationem quisquam, distinctio ipsa excepturi tempore. Lorem
            ipsum dolor sit amet consectetur adipisicing elit. Porro eaque
            labore ullam sint voluptatum exercitationem quisquam, distinctio
          </p>
          <br />
          <h2>Anabela Rose</h2>
        </div>
      </div>
    </div>
  );
}

export default FirstSection;
